<div
  class="overflow-hidden rounded-lg bg-white dark:bg-gray-900/20 shadow-sm font-header cursor-pointer"
>
  <div class="text-center">
    <div class="relative">
      <img [src]="image()" alt="The Villages Lifestyle Preview" class="w-full object-cover" />

      <div
        class="absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-1/2 w-44 h-44 sm:w-52 sm:h-52 bg-gray-200 dark:bg-gray-800 rounded-full text-sm sm:text-base flex flex-col items-center justify-center text-primary-500 dark:text-gray-500 border-8 border-white dark:border-gray-900/20"
      >
        Starting at
        <span class="block text-3xl sm:text-4xl leading-tight"
          >${{ price() }}<sup class="text-lg sm:text-xl">*</sup></span
        >
        per day
      </div>
    </div>

    <div class="flex flex-col items-center px-6 pb-4 gap-4 mt-24 sm:mt-28">
      <p class="text-2xl leading-none text-primary-500 dark:text-white text-center">
        Come for a
        <span class="italic font-accent text-6xl text-villages-gold-500 block leading-14"
          >lifestyle preview</span
        >
        Experience
      </p>

      <button
        type="button"
        class="rounded-md bg-primary-500 text-white px-8 py-6 text-lg font-semibold shadow-xs inset-ring inset-ring-gray-300 dark:inset-ring-gray-700 hover:bg-primary-700 cursor-pointer"
        (click)="lppClicked.emit()"
      >
        Learn More
      </button>
    </div>
  </div>

  <div
    class="px-4 pb-5 sm:px-6 sm:pb-6 text-center text-xs text-gray-600 dark:text-gray-500 font-body"
    [innerHTML]="footnote()"
  ></div>
</div>
